import styled from 'styled-components';

export const StyledManagementList = styled.div`
  .cml-wrapper {
    padding: 17px 0px;

    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      &-left {
        display: flex;
        align-items: center;
        gap: 12px;

        > div {
          margin-bottom: 0;
        }

        &-select {
          width: 258px;
          height: 40px;
          margin-bottom: 0;

          .MuiInputBase-root {
            padding: 0 !important;
            padding-left: 2px !important;
            padding-right: 26px !important;
          }
        }

        &-search {
          width: 258px;

          .MuiInputBase-root {
            padding-right: 0 !important;
          }
        }
      }
    }
  }
`;
